/**
 * @generated SignedSource<<d18c83ca777a916c309708462cba381a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddBlocksInput = {
  blocksData: any;
  clientMutationId?: string | null;
  noteId: string;
};
export type NoteCardAddBlocksMutation$variables = {
  input: AddBlocksInput;
};
export type NoteCardAddBlocksMutation$data = {
  readonly addBlocks: {
    readonly ok: boolean;
  } | null;
};
export type NoteCardAddBlocksMutation = {
  response: NoteCardAddBlocksMutation$data;
  variables: NoteCardAddBlocksMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddBlocksPayload",
    "kind": "LinkedField",
    "name": "addBlocks",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NoteCardAddBlocksMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NoteCardAddBlocksMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6121d5acb64732ab5514ae66a686c367",
    "id": null,
    "metadata": {},
    "name": "NoteCardAddBlocksMutation",
    "operationKind": "mutation",
    "text": "mutation NoteCardAddBlocksMutation(\n  $input: AddBlocksInput!\n) {\n  addBlocks(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "93386221e834e71a8d4f8e19b8b28dfd";

export default node;
